<template>
  <div>
    <borFrame :title="'分方案推送情况'" :iconShow="true" @iconClick="handleClick">
      <div v-if="list.length > 0">
        <div class="borFrame_content" v-if="tabShow">
          <div class="borFrame_content_item" v-for="(item, index) in list" :key="index">
            <span class="borFrame_content_item_title">{{ item.key }}</span>
            <van-slider bar-height="10px" v-model="item.percentage" />
            <span class="borFrame_content_item_title">{{ item.percentage + '%' }}</span>
          </div>
        </div>
        <div v-else>
          <TableDemo :columns="columns" :data="list"></TableDemo>
        </div>
        <p class="borFrame_content_more" v-if="list.length > 0">
          从当日预警推送情况来看，【{{ maxData.key }}】的预警信息最多为{{ maxData.num }}条（占比{{ maxData.percentage + '%' }}）
        <div class="borFrame_content_more_btn" @click="detailsClick">
          查看详情 >
        </div>
        </p>
      </div>
    </borFrame>
  </div>
</template>
<script>
import borFrame from "@/components/frame";
import TableDemo from "@/components/table";
import moment from 'moment';
import { warningScheme } from '@/api/index'
export default {
  name: 'Push',
  components: {
    borFrame,
    TableDemo
  },
  data() {
    return {
      tabShow: true,
      // 总数据
      columns: [
        {
          prop: 'key',
          label: '方案',
          width: '30%',
          align: 'center',
        },
        {
          prop: 'num',
          label: '数量',
          align: 'center',
          width: '30%',
        },
        {
          prop: 'percentage',
          label: '占比(%)',
          align: 'center',
        },
      ],
      list: [],
      maxData: {}
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClick() {
      this.tabShow = !this.tabShow
    },
    detailsClick() {
      this.$router.push({
        path: '/details',
        query: {
          time: this.$route.query.time
        }
      })
    },
    getList() {
      const time = this.$route.query.time;
      // time格式为2024年3月22日 将time格式化为2024-03-22
      const formatTime = moment(time, 'YYYY年M月D日').format('YYYY-MM-DD');
      //获取formatTime的开始时间和结束时间时间戳
      const startTime = moment(formatTime).startOf('day').valueOf();
      const endTime = moment(formatTime).endOf('day').valueOf();
      let data = {
        endTime: endTime,
        startTime: startTime,
        openId: localStorage.getItem('id')
      }
      warningScheme(data).then(res => {
        let arr = []
        for (let k = 0; k < res.topicStatistics.length; k++) {
          arr.push({
            key: res.topicStatistics[k].key,
            num: res.topicStatistics[k].num,
            percentage: Number((res.topicStatistics[k].num / res.sum * 100).toFixed(2))
          })
        }
        this.list = arr
        console.log(this.list);
        // 查找res数组对象中最大的num值索引
        let maxIndex = 0;
        for (let i = 1; i < this.list.length; i++) {
          if (this.list[i].num > this.list[maxIndex].num) {
            maxIndex = i;
          }
        }
        this.maxData = this.list[maxIndex];
      })
    }
  }
}
</script>
<style lang="less" scoped>
.borFrame_content {
  /* 文字内容之间的间距 */
  letter-spacing: 1px;
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;

  &_item {
    display: flex;
    width: 100%;
    align-items: center;

    &_title {
      font-size: .16rem;
      display: inline-block;
      width: 30%;
      // 文字溢出显示省略号
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.borFrame_content_more {
  background: #f8f8f8;
  letter-spacing: 1px;
  line-height: 1.5;
  margin-top: .1rem;

  &_btn {
    margin-top: .1rem;
    color: #9a9494;
    font-size: .14rem;
    text-align: right;
  }
}

/deep/ .van-slider__button {
  display: none;
}

/deep/ .van-slider__bar {
  // 背景颜色从左到右渐变
  background: linear-gradient(to right, #f5a623, #f7b731, #f9c83e, #fbd94c, #fee059, #fff366);
}
</style>